/** Name of the feature. */
export const SolanaSignIn = 'solana:signIn';
//# sourceMappingURL=signIn.js.map